import type { HelpTopic } from '@horof/shared';

/** «؟ مساعدة», screen by screen (doc 52): short steps, the buttons' words. */
export const HELP: HelpTopic[] = [
  {
    path: '/',
    title: 'الأداءات',
    steps: [
      'ابحث عن العضو بالاسم أو برقم العداد.',
      '«مدينون»: عليهم فواتير. «متأخرون»: تأخروا عن الأداء.',
      'افتح العضو لتسجيل ما دفعه.',
      '«مقبوضات اليوم»: ما استلمته اليوم.',
    ],
  },
  {
    path: '/member/:memberId',
    title: 'تسجيل أداء',
    steps: [
      'تحقق من اسم العضو ومن فواتيره غير المؤداة.',
      'اكتب المبلغ الذي استلمته. يمكن أداء جزء من الفاتورة.',
      'اضغط «تأكيد»، ثم «نعم، استلمت المبلغ».',
      'يمكنك إرسال الوصل للعضو عبر واتساب.',
    ],
  },
  {
    path: '/today',
    title: 'مقبوضات اليوم',
    steps: [
      'ما استلمته أنت اليوم، ومجموع الجمعية.',
      'قارن المجموع بالمال الذي معك قبل تسليمه.',
    ],
  },
  {
    path: '/bill/:billId',
    title: 'الفاتورة',
    steps: [
      'تفاصيل الفاتورة: القراءة والاستهلاك والمبلغ.',
      'ارجع إلى العضو لتسجيل الأداء.',
    ],
  },
];
